import { DataPeriod } from '@prisma/client';
import { CopyIcon, DownloadIcon, MaximizeIcon, RefreshCcwIcon } from 'lucide-react';
import i18n from '../../../../i18n/config';
import { UserReportContent } from '../../../reports/components/user-report-content';
import { UserReportText } from '../../../reports/components/user-report-text';
import { ArtifactAction } from '../elements/artifact';
import { TrackedTimeChartWidget, UserInfoWidget } from './widgets';
import type { User, UserTrackedTimeData } from './widgets';

export interface WidgetConfig {
  hasWidget: boolean;
  hasFullscreen: boolean;
  getTitle: () => string;
  getDescription?: (result: any) => string;
  renderNormal: (result: any, args: any) => React.ReactNode;
  renderFullscreen: (result: any, args: any) => React.ReactNode;
  getActions?: (result: any, args: any, onFullscreen: () => void) => React.ReactNode[];
}

export const WIDGET_REGISTRY: Record<string, WidgetConfig> = {
  // searchUsers: {
  //   hasWidget: true,
  //   hasFullscreen: false,
  //   getTitle: () => 'User Search Results',
  //   getDescription: (result) => {
  //     if (Array.isArray(result) && result.length > 0) {
  //       return `Found ${result.length} user(s) matching your search criteria`;
  //     }
  //     return 'No users found matching your search criteria';
  //   },
  //   renderNormal: (result, args) => {
  //     if (Array.isArray(result) && result.length > 0) {
  //       const user = result[0] as User;
  //       return (
  //         <UserInfoWidget
  //           key={user.id}
  //           user={user}
  //           size="md"
  //           showStatus={false}
  //           className="border rounded-md bg-card"
  //         />
  //       );
  //     }
  //     return (
  //       <div className="text-sm text-muted-foreground p-4 border rounded-md bg-muted/50">
  //         No users found matching your search criteria.
  //       </div>
  //     );
  //   },
  //   renderFullscreen: (result, args) => {
  //     if (Array.isArray(result) && result.length > 0) {
  //       const user = result[0] as User;
  //       return (
  //         <UserInfoWidget
  //           key={user.id}
  //           user={user}
  //           size="lg"
  //           showStatus={true}
  //           className="border rounded-md bg-card p-6"
  //         />
  //       );
  //     }
  //     return <div className="text-sm text-muted-foreground p-4">No users found</div>;
  //   },
  //   getActions: (result, args, onFullscreen) => {
  //     const actions: React.ReactNode[] = [];
  //     if (Array.isArray(result) && result.length > 0) {
  //       const user = result[0] as User;
  //       actions.push(
  //         <ArtifactAction
  //           key="copy"
  //           icon={CopyIcon}
  //           label="Copy user info"
  //           tooltip="Copy user information to clipboard"
  //           onClick={() => navigator.clipboard.writeText(JSON.stringify(user, null, 2))}
  //         />
  //       );
  //     }
  //     actions.push(
  //       <ArtifactAction
  //         key="refresh"
  //         icon={RefreshCcwIcon}
  //         label="Refresh"
  //         tooltip="Refresh search results"
  //       />
  //     );
  //     return actions;
  //   },
  // },
  // getUsersTrackedTime: {
  //   hasWidget: true,
  //   hasFullscreen: false,
  //   getTitle: () => 'Tracked Time Analytics',
  //   getDescription: (result) => {
  //     const trackedTimeData = result as { users: UserTrackedTimeData[] };
  //     return `Time tracking data for ${trackedTimeData.users.length} user(s)`;
  //   },
  //   renderNormal: (result, args) => (
  //     <TrackedTimeChartWidget data={result} args={args} className="border rounded-md bg-card" />
  //   ),
  //   renderFullscreen: (result, args) => (
  //     <TrackedTimeChartWidget data={result} args={args} className="border rounded-md bg-card p-6" />
  //   ),
  //   getActions: (result, args, onFullscreen) => {
  //     const trackedTimeData = result as { users: UserTrackedTimeData[] };
  //     return [
  //       <ArtifactAction
  //         key="download"
  //         icon={DownloadIcon}
  //         label="Export data"
  //         tooltip="Download tracked time data as CSV"
  //         onClick={() => {
  //           const csvData = trackedTimeData.users
  //             .map((user) => `${user.user.firstname} ${user.user.lastname},${user.totalTime}`)
  //             .join('\n');
  //           const blob = new Blob([`Name,Total Time\n${csvData}`], { type: 'text/csv' });
  //           const url = URL.createObjectURL(blob);
  //           const a = document.createElement('a');
  //           a.href = url;
  //           a.download = 'tracked-time-data.csv';
  //           a.click();
  //           URL.revokeObjectURL(url);
  //         }}
  //       />,
  //       <ArtifactAction
  //         key="copy"
  //         icon={CopyIcon}
  //         label="Copy data"
  //         tooltip="Copy tracked time data to clipboard"
  //         onClick={() => navigator.clipboard.writeText(JSON.stringify(trackedTimeData, null, 2))}
  //       />,
  //       <ArtifactAction
  //         key="refresh"
  //         icon={RefreshCcwIcon}
  //         label="Refresh"
  //         tooltip="Refresh tracked time data"
  //       />,
  //     ];
  //   },
  // },
  showReport: {
    hasWidget: true,
    hasFullscreen: true,
    getTitle: () => i18n.t('chat2:report.title'),
    getDescription: () => i18n.t('chat2:report.description'),
    renderNormal: (result, args) => <UserReportText data={result} loading={false} />,
    renderFullscreen: (result, args) => {
      const isProjectReport = result?.attendance !== undefined;
      const selectedRange = result?.processedDataPeriod?.period || DataPeriod.Weekly;
      return (
        <UserReportContent
          data={result}
          isLoading={false}
          selectedRange={selectedRange}
          isProjectReport={isProjectReport}
        />
      );
    },
    getActions: (result, args, onFullscreen) => [
      <ArtifactAction
        key="fullscreen"
        icon={MaximizeIcon}
        label={i18n.t('chat2:report.actions.fullscreen')}
        tooltip={i18n.t('chat2:report.actions.fullscreenTooltip')}
        onClick={onFullscreen}
      />,
      <ArtifactAction
        key="copy"
        icon={CopyIcon}
        label={i18n.t('chat2:report.actions.copy')}
        tooltip={i18n.t('chat2:report.actions.copyTooltip')}
        onClick={() => navigator.clipboard.writeText(JSON.stringify(result, null, 2))}
      />,
      <ArtifactAction
        key="refresh"
        icon={RefreshCcwIcon}
        label={i18n.t('chat2:report.actions.refresh')}
        tooltip={i18n.t('chat2:report.actions.refreshTooltip')}
      />,
    ],
  },
};

export const hasWidget = (toolName: string): boolean => {
  return WIDGET_REGISTRY[toolName]?.hasWidget ?? false;
};

export const hasFullscreen = (toolName: string): boolean => {
  return WIDGET_REGISTRY[toolName]?.hasFullscreen ?? false;
};

export const getWidgetConfig = (toolName: string): WidgetConfig | undefined => {
  return WIDGET_REGISTRY[toolName];
};
